import React from 'react';
import { Box } from '@mui/material';

const iconSx = {
  display: 'block',
};

function FigureIcon({ children, size = 26 }) {
  const height = (size * 36) / 24;

  return (
    <Box
      component="svg"
      viewBox="0 0 24 36"
      width={size}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      sx={iconSx}
      aria-hidden="true"
    >
      {children}
    </Box>
  );
}

export function FuturisticMaleIcon({ size = 26 }) {
  return (
    <FigureIcon size={size}>
      <circle cx="12" cy="4.6" r="3.1" fill="currentColor" />
      <path
        d="M5.5 12.6C5.5 10.2 8.1 8.8 12 8.8C15.9 8.8 18.5 10.2 18.5 12.6V19.8C18.5 21.2 17.4 22.3 16 22.3H15.2V31.9C15.2 33.7 13.8 35.1 12 35.1C10.2 35.1 8.8 33.7 8.8 31.9V22.3H8C6.6 22.3 5.5 21.2 5.5 19.8V12.6Z"
        fill="currentColor"
      />
    </FigureIcon>
  );
}

export function FuturisticFemaleIcon({ size = 26 }) {
  return (
    <FigureIcon size={size}>
      <circle cx="12" cy="4.6" r="3.1" fill="currentColor" />
      <rect x="8" y="9" width="8" height="7.4" rx="2.8" fill="currentColor" />
      <rect
        x="5.8"
        y="14"
        width="2.6"
        height="8.8"
        rx="1.3"
        fill="currentColor"
        transform="rotate(20 7.1 18.4)"
      />
      <rect
        x="15.6"
        y="14"
        width="2.6"
        height="8.8"
        rx="1.3"
        fill="currentColor"
        transform="rotate(-20 16.9 18.4)"
      />
      <path d="M12 16.2L18.1 28.1H5.9L12 16.2Z" fill="currentColor" />
      <rect x="8.5" y="28" width="2.9" height="7.1" rx="1.45" fill="currentColor" />
      <rect x="12.6" y="28" width="2.9" height="7.1" rx="1.45" fill="currentColor" />
    </FigureIcon>
  );
}
